import { useState } from 'react';
import AssistantChat from './AssistantChat';

export default function FloatingAssistant({ shoppingList, onAddToList, onTabChange, favourites, onToggleFavourite }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="floating-assistant">
      {open && (
        <div className="floating-panel">
          <div className="floating-panel-header">
            <span className="floating-panel-title">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
                <circle cx="9" cy="10" r="1" fill="currentColor" stroke="none"/>
                <circle cx="12" cy="10" r="1" fill="currentColor" stroke="none"/>
                <circle cx="15" cy="10" r="1" fill="currentColor" stroke="none"/>
              </svg>
              AI Shopping Assistant
            </span>
            <button className="floating-panel-close" onClick={() => setOpen(false)}>✕</button>
          </div>
          <div className="floating-panel-body">
            <AssistantChat shoppingList={shoppingList} onAddToList={onAddToList} onTabChange={onTabChange} favourites={favourites} onToggleFavourite={onToggleFavourite} />
          </div>
        </div>
      )}

      <button
        className={`floating-btn ${open ? 'floating-btn--open' : ''}`}
        onClick={() => setOpen(v => !v)}
        title={open ? 'Close assistant' : 'Open AI Shopping Assistant'}
        aria-label={open ? 'Close assistant' : 'Open AI Shopping Assistant'}
      >
        {!open && <span className="floating-btn-badge">AI</span>}
        {open ? (
          /* Open: two overlapping chat bubbles */
          <svg viewBox="0 0 28 28" width="30" height="30" fill="white">
            <path d="M20 4H6a3 3 0 00-3 3v8a3 3 0 003 3h1v3.5L11.5 18H20a3 3 0 003-3V7a3 3 0 00-3-3z"/>
            <path d="M24 10h1a3 3 0 013 3v6a3 3 0 01-3 3h-1v2.5L20.5 22H15a3 3 0 01-3-3v-1h5a5 5 0 005-5v-3z" opacity="0.55"/>
          </svg>
        ) : (
          /* Closed: speech bubble with three dots */
          <svg viewBox="0 0 28 28" width="30" height="30" fill="white">
            <path d="M14 3C7.925 3 3 7.477 3 13c0 2.136.67 4.116 1.81 5.74L3 25l6.51-1.71A11.1 11.1 0 0014 24c6.075 0 11-4.477 11-10S20.075 3 14 3z"/>
            <circle cx="9.5" cy="13" r="1.5" fill="#0C447C"/>
            <circle cx="14" cy="13" r="1.5" fill="#0C447C"/>
            <circle cx="18.5" cy="13" r="1.5" fill="#0C447C"/>
          </svg>
        )}
      </button>
    </div>
  );
}
